import { Location } from '@angular/common';

import { Component, ElementRef, OnInit } from '@angular/core';

import Map from 'ol/Map';

import View from 'ol/View';

import OSM from 'ol/source/OSM';

import { MapService } from 'src/app/Service/map.service';

import Feature from 'ol/Feature';

import { Icon, Style } from 'ol/style';

import { BingMaps, XYZ } from 'ol/source';

import TileLayer from 'ol/layer/Tile';

import VectorLayer from 'ol/layer/Vector';

import VectorSource from 'ol/source/Vector';

import axios from 'src/app/Service/axios';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import * as olProj from 'ol/proj';

import { Point } from 'ol/geom';

import Vector from 'ol/source/Vector';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { animate, state, style, transition, trigger } from '@angular/animations';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { ActivatedRoute, Router } from '@angular/router';

declare let $: any;

@Component({

  selector: 'app-save-school',

  templateUrl: './save-school.component.html',

  styleUrls: ['./save-school.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ])

  ]

})

export class SaveSchoolComponent implements OnInit {

  editMode: boolean = false;

  serviceAreas: any = [];

  list_search: any;

  searchFilter: any;

  baseLocation: any = [51.3833554, 35.6770113];

  source: any;

  vector: any;

  layers: any = [];

  map: any;

  bSchoolAbility: boolean = false;

  bSchoolTiket: boolean = false;

  bServiceAreas: boolean = false;

  bAddSchedule: boolean = false;

  list_ability: any[] = [];

  list_Ticket: any[] = [];

  list_City: any[] = [];

  iMobileDomain!: string | number;

  searchT_City = '';

  filteredCity: any = [];

  lst_Schedule: any = [];

  lstDistrict: any[] = [];

  lstLevel_List: any[] = [];

  lstSchoolType: any[] = [];

  SAInputs: FormGroup = this.formBuilder.group({
    iSystemUser: new FormControl(''),
    strSession: new FormControl(''),
    strComment: new FormControl(''),
    strTripRequestEndTime: new FormControl(''),
    iRadious: new FormControl(''),
    strAddress: new FormControl(''),
    iParkingRadious: new FormControl(''),
    iMissionRadious: new FormControl(''),
    fLat: new FormControl(''),
    fLon: new FormControl(''),
    fCityLat: new FormControl(''),
    fCityLon: new FormControl(''),
    strTerminalID: new FormControl(''),
    strBankName: new FormControl(''),
    tiCommission: new FormControl(''),
    strSchoolBusMedia: new FormControl(''),
    iMobileDomain: new FormControl(''),
    strCity: new FormControl(''),
    strBBBServerURL: new FormControl(''),
    strBBBSecretKey: new FormControl(''),
    tiEducationDistrict: new FormControl(0),
    tiEducationLevel: new FormControl(0),
    tiGender: new FormControl(0),
    tiSchoolType: new FormControl(0),
  })

  latoLong: FormGroup = this.formBuilder.group({

    latIn: new FormControl(''),

    longIn: new FormControl(''),

    strMobile: new FormControl('')

  })

  mdl_Schedule: FormGroup = this.formBuilder.group({

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    strTitle: new FormControl('', Validators.required),

    strSTime: new FormControl('', Validators.required),

    strETime: new FormControl('', Validators.required),

    iDuration: new FormControl('', Validators.required),

    iMobileDomain: new FormControl(''),

    iMadonik_Schedule_Time: new FormControl('-1'),

    index: new FormControl(''),

  })

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(

    private location: Location,

    private formBuilder: FormBuilder,

    private notificationService: NotificationService,

    private Notification: NotificationService,

    private gurdService: GurdServiceService,

    private otherService: OtherService,

    private router: ActivatedRoute,

    private route: Router

  ) { }

  ngOnInit(): void {

    $('.clockpicker').clockpicker({

      donetext: 'top',

      align: 'top',

      autoclose: true,

    });

    this.router.url.subscribe((segment) => {

      if (segment[0].path == 'ServiceAreas') this.bServiceAreas = true;

    })

    this.getListOfServiceArea();

    this.getListCity();

    this.getDistrict();

    this.bSchoolAbility = JSON.parse(this.gurdService.decrypt(localStorage.getItem('menu') as any)).bSchoolService_SchoolAbility;

    this.bSchoolTiket = JSON.parse(this.gurdService.decrypt(localStorage.getItem('menu') as any)).bSchoolService_SchoolTiket;

  }

  filterCity() {

    if (this.searchT_City == '') {

      this.filteredCity = [];

      this.SAInputs.controls['strCity'].setValue('')

    }

    else this.filteredCity = this.list_City.filter((item: any) => item.strCityName.includes(this.searchT_City));

  }

  selectedCity(item: any) {

    this.SAInputs.controls['strCity'].setValue(item.strCity)

    this.searchT_City = item.strCityName;

    this.filteredCity = [];

  }

  addSa() {

    this.SAInputs.reset();

    this.searchT_City = '';

    this.SAInputs.controls['strCity'].setValue('')

    this.SAInputs.controls['tiGender'].setValue('0')

    this.SAInputs.controls['tiSchoolType'].setValue('0')

    this.SAInputs.controls['tiEducationLevel'].setValue('0')

    this.SAInputs.controls['tiEducationDistrict'].setValue('0')

  }

  searchbox(value: any) {

    if (!this.searchFilter) this.searchFilter = this.serviceAreas;

    if (value.length == 0) {

      this.serviceAreas = this.searchFilter;

      this.searchFilter = false;

    }

    else {

      this.serviceAreas = this.searchFilter.filter((x: any) => x.strComment.startsWith(value))

    }

  }

  openEditModal(item: any) {

    this.searchT_City = item.strCityName;

    Object.keys(item).forEach(key => {

      this.SAInputs.get(key)?.setValue(item[key])

    })

  }

  sortBy(input: any) {
    if (this.serviceAreas.length > 0) {
      this.serviceAreas.sort((a: any, b: any) => {
        if (input == 0) {
          var textA = a.strComment.toUpperCase();
          var textB = b.strComment.toUpperCase();
        }
        if (input == 1) {
          var textA = a.strTripRequestEndTime;
          var textB = b.strTripRequestEndTime;
        }
        if (input == 2) {
          var textA: any = Number(a.iRadious);
          var textB: any = Number(b.iRadious);
        }

        if (input == 3) {
          return a.fLat - b.fLat;
        }

        if (input == 4) {
          return a.fLon - b.fLon;
        }
        if (textA > textB)
          return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
        if (textA < textB)
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        return
      })
    }
  }

  searchBy(search: any) {

    if (search.length > 2) {

      this.serviceAreas = this.list_search.filter((el: any) => {

        return (el.strComment && el.strComment.includes(search)) ||

          (el.strCityName && el.strCityName.includes(search)) ||

          (el.strGender && el.strGender.includes(search)) ||

          (el.strEducationLevel_strComment && el.strEducationLevel_strComment.includes(search)) ||

          (el.strSchoolType_strComment && el.strSchoolType_strComment.includes(search)) ||

          (el.strEducationDistrict_strComment && el.strEducationDistrict_strComment.includes(search))

      })

    }

    else if (search == '') this.serviceAreas = this.list_search;

  }

  async getListOfServiceArea() {

    this.otherService.Showspinner();

    var model = {

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    };

    let res = JSON.parse((await axios.post(`MobileDomain_ListUserAccess`, model)).data.toString());

    this.otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      this.route.navigate(['login']);

      return;

    }

    this.serviceAreas = res;

    this.list_search = res;

  }

  async getListCity() {

    var model = {

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    };

    let res = JSON.parse((await axios.post(`City_List`, model)).data.toString());

    // console.log(res)

    this.list_City = res;

  }

  async getDistrict() {

    var model = {

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    };

    let res = JSON.parse((await axios.post(`EducationDistrict_List`, model)).data.toString());

    this.lstDistrict = res;

    // -----------------------------------------------------------

    let res2 = JSON.parse((await axios.post(`EducationLevel_List`, model)).data.toString());

    this.lstLevel_List = res2;

    // -----------------------------------------------------------

    let res3 = JSON.parse((await axios.post(`SchoolType_List`, model)).data.toString());

    this.lstSchoolType = res3;

  }

  async EditSA() {

    if (this.bServiceAreas) {

      this.SAInputs.patchValue({

        strTripRequestEndTime: '',
        iRadious: '',
        strAddress: '',
        iParkingRadious: '',
        iMissionRadious: '',
        fLat: '',
        fLon: '',
        fCityLat: '',
        fCityLon: '',
        strTerminalID: '',
        strBankName: '',
        tiCommission: '',
        strSchoolBusMedia: '',
        strCity: '',
        strBBBServerURL: '',
        strBBBSecretKey: '',

      })

    }

    this.SAInputs.controls['iSystemUser'].setValue(this.gurdService.decrypt(localStorage.getItem('ID')!));

    this.SAInputs.controls['strSession'].setValue(this.gurdService.decrypt(localStorage.getItem('Session')!));

    if (this.editMode) {

      this.otherService.Showspinner();

      const URL = this.bServiceAreas ? 'MobileDomain_Edit4UserManager' : 'MobileDomain_Edit';

      let resp = JSON.parse((await axios.post(URL, this.otherService.stringNumberToNumber(this.SAInputs.value))).data.toString());

      this.otherService.nonespinner()

      if (resp.iResult == 0) return this.notificationService.showError(resp.strError);

      this.notificationService.showSuccess('تغییرات با موفقیت اعمال شد');

      this.getListOfServiceArea();

    }

    else {

      let resp = JSON.parse((await axios.post(`MobileDomain_Save`, this.SAInputs.value)).data.toString());

      if (resp.iResult == 0) return this.notificationService.showError(resp.strError)

      this.notificationService.showSuccess('تغییرات با موفقیت اعمال شد');

      this.getListOfServiceArea();
    }

    this.SAInputs.reset();

    $('#editSA').modal('hide');

  }

  async DeleteSA(item: any) {
    $.confirm({
      title: `آیا از حذف این ${this.bServiceAreas ? 'حوزه' : 'مدرسه'} اطمینان دارید ؟`,
      content: '',
      type: 'red',
      buttons: {
        ok: {
          text: "حذف",
          btnClass: 'btn-success',
          keys: ['enter'],
          action: async () => {
            var model = {
              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
              iMobileDomain: item.iMobileDomain
            };


            let res = JSON.parse((await axios.post(`MobileDomain_Delete`, model)).data.toString());
            if (res.iResult == 0)
              return this.notificationService.showError(res.strError);

            this.notificationService.showSuccess(`${item.strComment} با موفقیت حذف شد`);
            this.getListOfServiceArea();
          }
        },
        cancel: {
          text: "لغو",
        }
      }
    });
  }

  async getAddress() {

    var strAddress = document.getElementById('strAddress') as HTMLInputElement;

    if (strAddress.value != '') {

      let res = (await axios.post(`Geocoding`, { 'strAddress': strAddress.value }));

      if (res.data.fLat != 0 && res.data.fLon != 0) {

        this.baseLocation = [res.data.fLon, res.data.fLat];

        this.newOpenMap()
      }

      else this.newOpenMap()
    }

    else this.newOpenMap()

  }

  async confirmLatol() {

    var fOriginLon = document.getElementById('fOriginLon') as HTMLInputElement;

    var fOrigiLat = document.getElementById('fOrigiLat') as HTMLInputElement;

    var strAddress = document.getElementById('strAddress') as HTMLInputElement;

    let model = {

      fLat: this.latoLong.controls['latIn'].value,

      fLon: this.latoLong.controls['longIn'].value,

    }

    const address: any = await axios.post(`ReverseGeocoding`, model);

    this.SAInputs.controls['fLat'].setValue(this.latoLong.controls['latIn'].value)

    this.SAInputs.controls['fLon'].setValue(this.latoLong.controls['longIn'].value)

    this.SAInputs.controls['strAddress'].setValue(address.data.strAddress)

    if (address.data.strAddress != '') strAddress.value = address.data.strAddress;

    $('#maplat').modal('hide');

  }

  async showAbility(item: any) {

    this.iMobileDomain = item.iMobileDomain;

    var model = {

      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      iMobileDomain: item.iMobileDomain

    };

    let res = (await axios.post(`MobileDomainMadonikAbility_List`, model));

    this.list_ability = JSON.parse(res.data)

    $('#access_School').modal('show');
  }

  async onCheckbox_(value: boolean, item: any) {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iMobileDomain: this.iMobileDomain,

      strMadonikAbility: item.strMadonikAbility,

      bDelete: !value

    }

    let res = JSON.parse((await axios.post(`MobileDomainMadonikAbility_SaveorDelete`, model)).data.toString())

    if (res.iResult == 0) return this.Notification.showError(res.strError)

    else return this.Notification.showSuccess('عملیات با موفقیت انجام شد');

  }

  async showTicket(item: any) {

    this.iMobileDomain = item.iMobileDomain

    var model = {

      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      iMobileDomain: item.iMobileDomain

    };

    let res = (await axios.post(`MobileDomainSchool_TiketSubject_List`, model));

    this.list_Ticket = JSON.parse(res.data);

    $('#ticket_School').modal('show');

  }

  async onCheckbox_Ticket(value: boolean, item: any) {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iMobileDomain: this.iMobileDomain,

      tiTiketSubject: item.tiTiketSubject,

      bDelete: !value

    }

    let res = JSON.parse((await axios.post(`MobileDomainSchool_TiketSubject_SaveorDelete`, model)).data.toString())

    if (res.iResult == 0) return this.Notification.showError(res.strError)

    else return this.Notification.showSuccess('عملیات با موفقیت انجام شد');

  }

  async show_Schedule(item: any) {

    this.otherService.Showspinner();

    var model = this.otherService.stringNumberToNumber({

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      iMobileDomain: item.iMobileDomain


    })

    let res = JSON.parse((await axios.post(`Madonik_Schedule_ORG_List`, model)).data.toString());

    this.otherService.nonespinner();

    if (res.iResult == 0) return this.notificationService.showError(res.strError)

    this.lst_Schedule = res;

    this.bAddSchedule = false;

    this.mdl_Schedule.controls['iMobileDomain'].setValue(item.iMobileDomain);

    $("#Std_Schedule_Modal").modal('show');

  }

  async saveSchedule() {

    this.mdl_Schedule.get('strSTime')?.setValue($("#Stime").val())

    this.mdl_Schedule.get('strETime')?.setValue($("#Etime").val())

    if (this.mdl_Schedule.invalid) return this.notificationService.showError('لطفا فرم را با دقت تکمیل کنید');

    if (!this.editMode) {

      this.otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Madonik_Schedule_Time_Save`, this.otherService.stringNumberToNumber(this.mdl_Schedule.value))).data);

      this.otherService.nonespinner();

      if (res.iResult == 0) return this.notificationService.showError(res.strError);

      this.lst_Schedule.push(res[0]);

      this.bAddSchedule = false;

      return this.notificationService.showSuccess('عملیات با موفقیت انجام شد');

    }

    else {

      this.otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Madonik_Schedule_Time_Edit`, this.otherService.stringNumberToNumber(this.mdl_Schedule.value))).data);

      this.otherService.nonespinner();

      if (res.iResult == 0) return this.notificationService.showError(res.strError);

      this.lst_Schedule[this.mdl_Schedule.get('index')?.value] = (res[0]);

      this.bAddSchedule = false;

      return this.notificationService.showSuccess('عملیات با موفقیت انجام شد');

    }

  }

  goBack() {

    this.location.back();
  }

  newOpenMap() {

    this.latoLong.get('latIn')?.setValue('');

    this.latoLong.get('longIn')?.setValue('');

    $('#maplat').modal('show');

    setTimeout(() => {

      if (this.map) this.map.setTarget(null);

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      var iconStyle = new Style({

        image: new Icon(({

          anchor: [0, 46],

          anchorXUnits: 'fraction',

          anchorYUnits: 'pixels',

          size: [48, 48],

          opacity: 1,

          src: '../../assets/Img/marker4.png'

        }))

      });


      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );

      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {

          this.layers.push(

            new TileLayer({

              visible: false,

              preload: Infinity,

              source: new BingMaps({

                // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],

              }),

            }),

          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


      }



      this.map = new Map({

        layers: this.layers,

        target: 'map',

        view: new View({

          center: olProj.fromLonLat(this.baseLocation),

          zoom: 16,

        }),

      });

      const marker = new Feature({

        geometry: new Point(olProj.fromLonLat(this.baseLocation)),

      });

      const vectorLayer = new VectorLayer({

        source: new VectorSource({

          features: [marker],

        }),

        style: new Style({

          image: new Icon({

            src: '../../assets/Img/marker4.png',

            scale: 1.0,

          }),

        }),

      });

      this.map.addLayer(vectorLayer);

      this.map.on('click', (e: any) => {

        this.map.removeLayer(vectorLayer)

        if (e.dragging) return;

        var coords = olProj.toLonLat(e.coordinate);

        this.latoLong.controls['latIn'].setValue(coords[1])

        this.latoLong.controls['longIn'].setValue(coords[0])

        var iconGeometry = new Point(e.coordinate)

        var iconFeature = new Feature({

          geometry: iconGeometry,

        });

        iconFeature.setStyle(iconStyle);

        var vectorSource = new Vector({

          features: [iconFeature]

        });

        var dinamicPinLayer = new VectorLayer({

          source: vectorSource

        });

        this.map.getLayers().forEach((layer: VectorSource) => {

          if (layer?.getKeys().length < 11)

            this.map.removeLayer(layer);
        });

        this.map.addLayer(dinamicPinLayer);
      })

      this.map.on('pointermove', (e: any) => {

        var pixel = this.map.getEventPixel(e.originalEvent);

        var hit = this.map.hasFeatureAtPixel(pixel);

        this.map.getViewport().style.cursor = 'pointer';

      });

    }, 500);

  }

  showSchedule_Add(item?: any, index?: number) {

    if (item) {

      Object.keys(item).forEach((key) => {

        this.mdl_Schedule.get(key)?.setValue((item as any)[key])

      })

      this.mdl_Schedule.controls['index'].setValue(index);

      this.editMode = true;

      this.bAddSchedule = true;

      setTimeout(() => {

        $('.clockpicker').clockpicker({

          donetext: 'top',

          align: 'top',

          autoclose: true,

        });

      }, 100);


    }

    else {

      this.mdl_Schedule.patchValue({

        iMadonik_Schedule_Time: '',

        strTitle: '',

        strSTime: '',

        strETime: '',

        iDuration: '',

      })

      this.bAddSchedule = true;

      this.editMode = false;

      setTimeout(() => {

        $('.clockpicker').clockpicker({

          donetext: 'top',

          align: 'top',

          autoclose: true,

        });

      }, 100);

    }

  }

  removeSchedule(item: any, index: number) {

    $.confirm({

      title: `آیا از حذف اطمینان دارید؟ `,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            Object.keys(item).forEach(key => {

              this.mdl_Schedule.get(key)?.setValue(item[key])

            })

            this.otherService.Showspinner();

            let res = JSON.parse((await axios.post(`Madonik_Schedule_Time_Edit`, this.otherService.stringNumberToNumber(this.mdl_Schedule.value))).data.toString());

            this.otherService.nonespinner();

            if (res.iResult == 0) return this.notificationService.showError(res.strError);

            this.lst_Schedule.splice(index, 1)

            this.notificationService.showSuccess('با موفقیت حذف شد');

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }



}
